import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import EditFormPartial from './EditFormPartial.js';
import Page from '../Page.js';
import PAGES from '../../data/PagesConstants.js';
import uiManager from '../../../config/ui.js';
import LeadsEarningConfig from '../../models/LeadsEarningConfig.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const Edit = (props) => {
  const [leadsEarningConfig, setLeadsEarningConfig] = useState((new LeadsEarningConfig()).toStateJson());
  const [fetchApi] = getApi('showLeadsEarningConfig')
  const [updateApi] = getApi('updateLeadsEarningConfig');
  const navigate = useNavigate();
  const params = useParams();
  let leadsEarningConfigObj = new LeadsEarningConfig();

  useEffect(() => {
    getRecord({ id: params.id });
  }, []);

  const getRecord = async (params) => {
    try {
      const response = await fetchApi(params).unwrap();
      setLeadsEarningConfig((new LeadsEarningConfig(response.data.lead_earning_configuration, true)).toStateJson());
    } catch (error) {
      toast.error("Something Went Wrong While Fetching Data")
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      toast.success('Updated Successfully');
      navigate(-1);
    } catch (error) {
      leadsEarningConfigObj.set_api_errors(error.data.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      updateRecord(new LeadsEarningConfig(leadsEarningConfig).toEditApiJson());
    } catch(error){
      setLeadsEarningConfig(new LeadsEarningConfig(leadsEarningConfig));
    }
  }

  const handleCancelFunction = () => {
    navigate(-1);
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditLeadsEarningConfigsPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Leads Earning Configuration", url: '/leads_earning_configs'}, { label: "Update" }]}
    className={'leads-earning-configs-edit-page'}
    >
      <PageContentWrapper contentHeading={"Update"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <EditFormPartial leadsEarningConfig={leadsEarningConfig} setLeadsEarningConfig={setLeadsEarningConfig} />
              <div className='mb-4 col-md-12'>
                <div>
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>
                    Back
                  </button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
}

export default Edit;
